var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork_6",
    "data-name": "Artwork 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.55,
    height: 18.523,
    viewBox: "0 0 8.55 18.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M817.293,237.234h-2.018c-.713,0-.861.292-.861,1.029v1.781h2.88l-.277,3.128h-2.6v9.341h-3.73v-9.3h-1.94v-3.167h1.94v-2.493c0-2.34,1.252-3.562,4.027-3.562h2.583Z",
    transform: "translate(-808.743 -233.989)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.53eced93c2c110a9af1d9bdf860f82a0.svg";
export { ForwardRef as ReactComponent };